import { UserProfile } from '@/modules/auth/types';
import { OnboardingFlow } from '@/pages/corporate/routes/workeffy';

/**
 * Which persona flow the workeffy onboarding SPA should run for this user.
 *
 * Admins take `f_adm`. The SPA also declares `co_adm` (invited co-admin) and `b2c`, but
 * academy has no discriminator for either today — `user.graphql` selects `isStaff` and not
 * `staffRoleIds` — and `f_adm`/`co_adm` are slated to merge. Return type stays the full
 * union so adding an arm here is the only edit needed.
 */
export const resolveOnboardingFlow = (user: Pick<UserProfile, 'isStaff'>): OnboardingFlow =>
  user.isStaff ? 'f_adm' : 'employee';
